import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import { PATH_SUGGESTIONS } from '../../constants/Constants'
import Actions from '../Actions/Actions'

import { diffArrays, getErrorFields, getErrorMessages } from '../../helpers'
import { translate, Translate } from 'react-i18nify'

import { diffProfileItems, getCleanCompetences, getCompetences } from '../../store/actions/user'

let map

class FormCompetences extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errors: [],
            showSuggested: true,
            suggestedCompetences: [],
            allCompetences: [],
            checked: [],
            manual: [],
            add: false,
            filterValue: '',
            loading: false,
            fetching: true,
            roles: false,
        }

        this.isChecked = this.isChecked.bind(this)
        this.getClassNames = this.getClassNames.bind(this)
        this.onCheckboxChange = this.onCheckboxChange.bind(this)
        this.filter = this.filter.bind(this)
    }

    componentDidMount() {
        console.log('Get form competences')

        const checkedCompetences =
            this.props.competences !== undefined
                ? this.props.competences.map((item) => {
                      return item.id
                  })
                : []
        this.setState({ checked: checkedCompetences })
        getCompetences(
            this.props.auth,
            (response) => {
                this.setState({
                    suggestedCompetences: response,
                    fetching: false,
                })
            },
            () => {},
        )
        getCleanCompetences((response) => {
            this.setState({
                allCompetences: response,
                fetching: false,
            })
        })
    }

    cancel() {
        this.props.onCancel()
    }

    isChecked(item) {
        let checked = this.state.checked

        return checked.indexOf(item.id) > -1
    }

    getClassNames(item) {
        let names = 'form__item'

        if (this.isChecked(item)) {
            names += ' form__item--selected'
        }

        return names
    }

    contains(list, item) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].id === item.id) {
                return true
            }
        }

        return false
    }

    onCheckboxChange(e, item) {
        if (e.target.checked) {
            this.check(item)
        } else {
            this.uncheck(item)
        }
    }

    check(item) {
        if (!this.isChecked(item)) {
            let checked = this.state.checked
            let items = this.state.items

            checked.push(item.id)

            this.setState({
                checked: checked,
            })
        }
    }

    uncheck(item) {
        if (this.isChecked(item)) {
            let checked = this.state.checked
            let items = this.state.items

            //Remove id of the item from the checked list.
            checked.splice(checked.indexOf(item.id), 1)

            this.setState({
                checked: checked,
            })
        }
    }

    save() {
        if (!this.state.loading) {
            this.setState({
                loading: true,
            })

            let todo = diffArrays(this.props.competences, this.state.checked, 'id')

            this.props.dispatch(
                diffProfileItems(
                    'competences',
                    todo.toAdd,
                    todo.toRemove,
                    this.props.auth,
                    () => {
                        this.setState({ loading: false })
                        this.props.onSave()
                    },
                    (status, errors) => {
                        console.log('[ Adding job interest failed ]', status, errors)
                        this.setState({ loading: false, errors: errors })
                    },
                ),
            )
        }
    }

    error(status, object) {
        console.log('Error saving competences', status)

        this.setState(
            {
                errors: [],
                fields: [],
                loading: false,
            },
            () => {
                if (object.hasOwnProperty('errors')) {
                    let messages = getErrorMessages(object.errors, map)
                    let fields = getErrorFields(object.errors)

                    this.addErrors(messages)
                    this.addErrorFields(fields)
                }
            },
        )
    }

    getFiltered() {
        const { showSuggested, filterValue, allCompetences, suggestedCompetences } = this.state

        return (showSuggested ? suggestedCompetences : allCompetences).filter(
            (el) =>
                el.name.toLowerCase().includes(filterValue) ||
                el.description.toLowerCase().includes(filterValue),
        )
    }

    filter(e) {
        let value = e.target.value.toLowerCase()
        this.setState({
            filterValue: value,
        })
    }

    render() {
        const { showSuggested } = this.state
        const filteredCompetences = this.getFiltered()

        return (
            <form
                className={this.props.className}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        //Enter pressed
                        this.save()
                    }
                }}
            >
                {/* Show the full list of roles */}
                <div className="form__fieldset">
                    <div className="form__header">
                        <p>{translate('profile.competences_intro')}</p>
                        <p>
                            {translate('profile.competences_helper_part_1')}&nbsp;
                            <span
                                className={'text--link'}
                                onClick={(e) => {
                                    this.cancel()
                                    this.props.showRoles()
                                }}
                            >
                                {translate('profile.compentences_helper_here')}
                            </span>
                            &nbsp;
                            {translate('profile.competences_helper_part_2')}&nbsp;
                            <span>
                                {translate('profile.competences_helper_part_3')}
                                &nbsp;
                                <span
                                    className={'text--link'}
                                    onClick={() => {
                                        this.setState((s) => ({ showSuggested: !s.showSuggested }))
                                    }}
                                >
                                    {translate('profile.compentences_helper_here')}
                                </span>
                                &nbsp;
                                {showSuggested
                                    ? translate('profile.competences_helper_part_4')
                                    : translate('profile.competences_helper_part_4_all')}
                            </span>
                        </p>
                    </div>
                    <hr />
                    <input
                        className="form__input--text"
                        type="text"
                        placeholder={translate('profile.filter_competences')}
                        onChange={(e) => this.filter(e)}
                        value={this.state.filterValue}
                        tabIndex="1"
                        autoFocus="autofocus"
                    />
                    <div className="form__items">
                        {this.state.fetching && (
                            <div className="actions min-height">
                                <div className="actions__action is-loading center_align" />
                            </div>
                        )}

                        {filteredCompetences &&
                            filteredCompetences.map((item, index) => {
                                return (
                                    <div
                                        className={this.getClassNames(item)}
                                        key={'competence-' + index}
                                    >
                                        <div className="form__checkbox">
                                            <input
                                                type="checkbox"
                                                name={item.id}
                                                id={item.id}
                                                className="form__checkbox__input"
                                                checked={this.isChecked(item)}
                                                onChange={(e) => this.onCheckboxChange(e, item)}
                                            />
                                            <label
                                                className="form__checkbox__label"
                                                htmlFor={item.id}
                                            >
                                                {item.name}
                                            </label>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                )
                            })}

                        {filteredCompetences.length === 0 && !this.state.fetching && (
                            <div className="actions text-center">
                                <div>{translate('profile.no_results')}</div>
                            </div>
                        )}
                    </div>
                    <hr />
                </div>

                <Actions>
                    <Link
                        className="actions__action--cancel"
                        onClick={() => this.cancel()}
                        tabIndex="2"
                    >
                        <Translate value="profile.cancel" />
                    </Link>
                    <Link
                        className={
                            'actions__action--save' + (this.state.loading ? ' is-loading' : '')
                        }
                        onClick={() => this.save()}
                        tabIndex="3"
                    >
                        <Translate value="profile.save" />
                    </Link>
                </Actions>
            </form>
        )
    }
}

FormCompetences.propTypes = {
    className: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    showRoles: PropTypes.func.isRequired,
    edit: PropTypes.object,
}

function mapStateToProps(state) {
    const { auth, user, config } = state
    const { profile } = user
    const { competences } = profile

    return {
        auth,
        user,
        config,
        competences,
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FormCompetences)
